import type { IAdminUserDetail } from '@/entities/admin-user.entity';
import { formatProfitUsd } from '@/lib/format-profit';
import { AtSignIcon, BoxIcon, CalendarIcon, UsersIcon, WalletIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface UserStatsProps {
	user: IAdminUserDetail;
}

export default function UserStats({ user }: UserStatsProps) {
	const stats = [
		{
			icon: WalletIcon,
			label: 'Профит',
			value: `$${formatProfitUsd(user.profitAmount)} · ${user.profitCount}`,
			color: 'text-chart-5',
		},
		{
			icon: UsersIcon,
			label: 'Клиенты',
			value: `${user.onlineClientsCount} / ${user.clientsCount}`,
			color: 'text-chart-2',
		},
		{
			icon: BoxIcon,
			label: 'Билды',
			value: `${user.successBuildsCount} / ${user.buildsCount}`,
			color: 'text-foreground',
		},
		{
			icon: AtSignIcon,
			label: 'Telegram',
			value: user.tgUsername ? `@${user.tgUsername}` : '—',
			color: 'text-foreground',
		},
	];

	return (
		<div className='grid grid-cols-2 gap-2'>
			{stats.map(({ icon: Icon, label, value, color }) => (
				<div key={label} className='rounded-md border border-border bg-card p-3 flex flex-col gap-1.5'>
					<div className='flex items-center gap-1.5 text-xs text-muted-foreground'>
						<Icon size={14} className='opacity-50' />
						{label}
					</div>
					<span className={`text-sm font-semibold tabular-nums truncate ${color}`}>{value}</span>
				</div>
			))}
			<div className='col-span-2 rounded-md border border-border bg-card p-3 flex items-center justify-between gap-2'>
				<div className='flex items-center gap-1.5 text-xs text-muted-foreground'>
					<CalendarIcon size={14} className='opacity-50' />
					Регистрация
				</div>
				<span className='text-sm font-medium'>
					<TimeAgo date={user.createdAt} formatter={formatter} />
				</span>
			</div>
		</div>
	);
}
